import PropTypes from 'prop-types';
import React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { useScollingContainerStyles } from '../styles';

export const ScopeBarScrollingContainer = ({ children }) => {
  const styles = useScollingContainerStyles();

  return (
    <div className={mergeClasses('scope-bar-scrolling-container', styles.root, styles.scopeBar)}>
      {children}
    </div>
  );
};

ScopeBarScrollingContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export const ScopePanelScrollingContainer = ({ children }) => {
  const styles = useScollingContainerStyles();

  return (
    <div
      className={mergeClasses('scope-panel-scrolling-container', styles.root, styles.scopePanel)}
    >
      {children}
    </div>
  );
};

ScopePanelScrollingContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
